//#region src/utils/are-files-duplicate.ts
function e(e, t) {
	return e.name === t.name && e.size === t.size && e.lastModified === t.lastModified;
}
//#endregion
export { e as areFilesDuplicate };
